export const IMAGE_UPLOAD = "IMAGE_UPLOAD";
export const DOCUMENT_UPLOAD = "DOCUMENT_UPLOAD";
export const DOCUMENT_UPLOAD_PUBLIC = "DOCUMENT_UPLOAD_PUBLIC";
export const EXCEL_UPLOAD = "EXCEL_UPLOAD";
export const MEDIA_UPLOAD = "MEDIA_UPLOAD";
